import {useEffect} from "react";
import {Alert, IconButton} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import ToastService from "./ToastService";
import {useSnackbar} from "notistack";
import {useTranslation} from "react-i18next";

function Toast() {
  const {t} = useTranslation();
  const {enqueueSnackbar, closeSnackbar} = useSnackbar();

  // L'abonnement est pris dans un effet et relâché au démontage. Souscrire depuis le corps
  // du composant en accumulait un nouveau à chaque rendu, sans jamais s'en désabonner : chaque
  // message était alors empilé autant de fois qu'il y avait d'abonnements.
  // `enqueueSnackbar` et `closeSnackbar` ont une identité stable (notistack les mémorise dans
  // l'état de son provider), donc l'effet ne se rejoue pas.
  useEffect(() => {
    const messageSubscription = ToastService.getSubject().subscribe({
      next: (toastMessage) => {
        enqueueSnackbar({
          variant: "default",
          autoHideDuration: 4000,
          // `message` n'est pas affiché ici (le rendu passe par `content`) mais c'est la clé sur
          // laquelle notistack déduplique. Sans lui, tous les toasts ont un `message` undefined :
          // ils sont donc tous considérés comme des doublons entre eux et un seul est affiché à
          // la fois, les suivants étant silencieusement ignorés.
          message: toastMessage.label,
          preventDuplicate: true,
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "right",
          },
          content: (key) => (
            <Alert id="toaster" severity={toastMessage.severity} sx={{width: "100%"}}>
              {toastMessage.label}
              <IconButton
                size="small"
                aria-label={t("action.close")}
                color="inherit"
                onClick={() => closeSnackbar(key)}>
                <CloseIcon fontSize="small" />
              </IconButton>
            </Alert>
          ),
        });
      },
    });

    return () => {
      messageSubscription.unsubscribe();
    };
  }, [enqueueSnackbar, closeSnackbar]);

  return <></>;
}

export default Toast;
